export const defaultCitySelectModelData = {
  city: `Город не определен`,
  isModalOpened: false
};

export const defaultModalModelData = {
  isActive: false,
  isInit: false,
  currentLocality: null,
  isSuggestionsShown: false
};

export const MODAL_MAIN_CLASS = `city-select-modal-wrapper`;

export const USER_CITY_STORAGE_KEY = `userCity`;

export const ActionType = {
  SET_CITY: `SET_CITY`,
  OPEN_TRIGGER_CLICK: `OPEN_TRIGGER_CLICK`,
  CHANGE_CITY: `CHANGE_CITY`,
  SHOW_SUGGESTIONS: `SHOW_SUGGESTIONS`,
  HIDE_SUGGESTIONS: `HIDE_SUGGESTIONS`,
  CLOSE_MODAL: `CLOSE_MODAL`
};

export const SET_CITY_ANIMATION_DURATION = 100;

export const MODAL_ITEMS_NUMBER = 24;

export const INPUT_FOCUS_TIMEOUT_TIME = 200;

export const SUGGESTIONS_SEARCH_MIN_CHARS = 3;
